import { Common } from 'src/domains/common/Common';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

export const shouldKeepSessionPingAlive = (common: Common): boolean => {
    const gameModalState = AppCasinoState.get(common).gameModalState;

    if (
        gameModalState.regularGameModel !== null ||
        gameModalState.miniGameModel !== null ||
        gameModalState.bingoMiniGameModel !== null
    ) {
        return true;
    }

    return StreamingState.get(common).isStreamOpen;
};
